import moment from 'moment'
var padDate=function(va){
  va=va<10?'0'+va:va;
  return va
}

const dfilters = {
  formatDate:function (val) {
    var value=new Date(val);
    var year=value.getFullYear();
    var month=padDate(value.getMonth()+1);
    var days=padDate(value.getDate());

    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var months = day * 30;
    var time1 = new Date().getTime();//当前的时间戳
    var time2 = Date.parse(new Date(val));//指定时间的时间戳
    var time = time1 - time2;
    var result = null;
     if (time / months >= 1) {
      result = year+'-'+month+'-'+days+' '
    } else if (time / week >= 1) {
        result = year+'-'+month+'-'+days+' '
    } else if (time / day >= 1) {
        result =  parseInt(time / day) + "天前";
    } else if (time / hour >= 1) {
        result = parseInt(time / hour) + "小时前";
    } else if (time / minute >= 1) {
        result = parseInt(time / minute) + "分钟前";
    } else {
        result = "刚刚";
    }
    return result;

    // return year+'-'+month+'-'+days+' '
  },
  formatDateT:function (val) {
    var value=new Date(val);
    var year=value.getFullYear();
    var month=padDate(value.getMonth()+1);
    var days=padDate(value.getDate());

    

    return year+'-'+month+'-'+days+' '
  },
  sexFilter(militaryFirst) {
    switch (militaryFirst) {
      case 1:
        return '男';
        break;
      case 2:
        return '女';
        break;
      default:
        return '-';
        break;
    }
  },

  payStatus(status) {
    switch (status) {
      case 1:
        return '未支付';
        break;
      case 2:
        return '已付款';
        break;
      case 3:
        return '已失效';
        break;
    }
  },
  
  feedbackFilter(jobNature) {
    switch (jobNature) {
      case 1:
        return '待处理';
        break;
      case 2:
        return '待定';
        break;
      case 3:
        return '可面试';
        break;
      case 4:
        return '不合适';
        break;
    }
  },
  militaryFirstFilter(militaryFirst) {
    switch (militaryFirst) {
      case 0:
        return '否';
        break;
      case 1:
        return '是';
        break;
      default:
        return '-';
        break;
    }
  },
  cardType(cardType) {
    switch (cardType) {
      case 1:
        return '充值卡';
        break;
      case 2:
        return '课程卡';
        break;
      case 3:
        return '适应性培训课程卡';
        break;
      case 4:
        return '安置人员课程卡';
        break;
      case 5:
        return '安置人员课程卡';
        break;
      default:
        return '-';
        break;
    }
  },
  fprice(price) {
    return (parseFloat(price) / 100).toFixed(2)
  },
  fauthor(str) {
    let author = ""
    if (str) {
      str.split(',').forEach(item => {
        author = `${author}\xa0\xa0${item}`
      })
    }
    return author
  },
  fcost(type) {
    // 	integer($int32)1：在线充值 2：充值卡充值 3：消费
    switch (type) {
      case 1:
        return '在线充值';
        break;
      case 2:
        return '充值卡充值';
        break;
      case 3:
          return '消费';
          break;
      case 99:
        return '适应性培训课程卡';
        break;
      default:
        return '消费';
        break;
    }
    // return type < 2? "在线充值" : type<3? "充值卡充值" : "消费"
  },
  tradeType(type){
    switch (type) {
      case 'COURSE_CARD':
        return '课程卡激活';
        break;
      case 'COURSE_CARD_OTHER':
        return '安置人员课程卡';
        break;
      case 'BOUGHT_IN_OTHER':
          return '安置人员课程卡';
          break;
    }

  },
  ftime(value) {
    let currentTime = moment.duration(value, "seconds");
    // 将获取到的下轮间隔秒数转换成时分秒
    return moment({
      h: currentTime.hours(),
      m: currentTime.minutes(),
      s: currentTime.seconds(),
    }).format("HH:mm:ss");
  }
}
export default dfilters;



// WEBPACK FOOTER //
// ./src/utils/dfilters.js